import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import {
	Grid,
  TextField,
  Checkbox,
  Button,
  Link
} from '@mui/material';
import Autocomplete from '@mui/lab/Autocomplete';
import { Text } from 'shared/components';
import {
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon
} from '@mui/icons-material';

const QsForm = ({ donors, handleSave, selectedRow, dashboards = [] }) => {

  const [hasChanged, setHasChanged] = useState(false);

  const { values, setFieldValue, errors, handleSubmit, ...rest } = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: {
			id: null,
      name: '',
			information: '',
      awsId: '',
      accountList: []
    },
    onSubmit: (values, { resetForm }) => {
      const data = {
        ...values,
        accountList: JSON.stringify(values.accountList.map(({id}) => parseInt(id)))
      };
      handleSave(data, resetForm);
    },
		validate: (values) => {
			const errors = {};
			if (values.information && values.information.length > 300) {
				errors.information = 'Description should not be longer than 300 characters';
      }
			return errors;
    }
  });

  useEffect(() => {
    if (selectedRow) {
      const { dbId, name, information, awsId, accountList } = selectedRow;
      setFieldValue('id', dbId);
      setFieldValue('name', name);
      setFieldValue('information', information);
      setFieldValue('awsId', awsId);
      setFieldValue('accountList', accountList);
    }
  }, [selectedRow]);

  const handleOpenDashboard = () => {
    window.open(`/account/qs/${values.awsId}`, '_blank');
  };

  const isDisabled = (!values.information || !values.accountList || values.accountList.length === 0);

  const handleChangeDescription = (value) => {
    setHasChanged(true);
    setFieldValue('information', value);
  };

  const handleChangeDonors = (value) => {
    setHasChanged(true);
    setFieldValue('accountList', value);
  };

  return (
    <Grid container direction="row" justify="center" alignItems="center">
        <Grid item xs={12} sm={8}>
          <Grid items xs={12} style={{marginTop: '10px'}}>
            Display dashboard name:
          </Grid>
          <Grid item xs={12} style={{marginBottom: '10px'}}>
            <Text variant="body1">{values.name}</Text>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button disabled={!hasChanged || isDisabled} onClick={handleSubmit} style={{float: 'right'}}>SAVE</Button>
        </Grid>
      <Grid items xs={12}>
        Description:
      </Grid>
      <Grid item xs={12}>
        <TextField
          placeholder="(Max 300 characters)"
          variant="outlined"
          size="small"
          fullWidth
          value={values.information}
          onChange={e => handleChangeDescription(e.target.value)}
          error={errors.information}
          multiline
          rows={4}
          helperText={errors.information}
        />
      </Grid>
      <Grid items xs={12} style={{marginTop: '10px'}}>
        AWS ID:
      </Grid>
      <Grid item xs={12} style={{marginBottom: '10px'}}>
        <Link style={{cursor: 'pointer'}} onClick={handleOpenDashboard} variant="body1">{values.awsId}</Link>
      </Grid>
      <Grid items xs={12}>
        Enabled for donors:
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          options={donors}
          value={values.accountList}
          onChange={(_, value) => handleChangeDonors(value)}
          getOptionLabel={option => option.name}
          renderOption={(option, { selected }) => (
            <>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small"/>}
                checkedIcon={<CheckBoxIcon fontSize="small"/>}
                checked={selected}
              />
              <Text variant="body1">{option.name}</Text>
            </>
          )}
          renderInput={params => (
            <TextField
              {...params}
              variant="outlined"
              label={`Donors: ${values.accountList.length} selected`}
            />
          )}
          multiple
          disableCloseOnSelect
        />
      </Grid>
  </Grid>
  );
};

export default QsForm;
